import MuiChip, { type ChipProps } from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/CloseOutlined";
import { misc } from "../../theme/tokens";

const customChipColors: Record<string, { bg: string; color: string; deleteIcon: string }> = {
  teal:       { bg: misc.teal[50],       color: misc.teal[700],       deleteIcon: misc.teal[400] },
  orange:     { bg: misc.orange[50],     color: misc.orange[700],     deleteIcon: misc.orange[400] },
  purple:     { bg: misc.purple[50],     color: misc.purple[700],     deleteIcon: misc.purple[400] },
  pink:       { bg: misc.pink[50],       color: misc.pink[700],       deleteIcon: misc.pink[400] },
  fuchsia:    { bg: misc.fuchsia[50],    color: misc.fuchsia[700],    deleteIcon: misc.fuchsia[400] },
  orangeDark: { bg: misc.orangeDark[50], color: misc.orangeDark[700], deleteIcon: misc.orangeDark[400] },
  green:      { bg: misc.green[50],      color: misc.green[700],      deleteIcon: misc.green[400] },
  indigo:     { bg: misc.indigo[50],     color: misc.indigo[700],     deleteIcon: misc.indigo[400] },
  rose:       { bg: misc.rose[50],       color: misc.rose[700],       deleteIcon: misc.rose[400] },
  blueLight:  { bg: misc.blueLight[50],  color: misc.blueLight[700],  deleteIcon: misc.blueLight[400] },
};

export type ForestChipColor = ChipProps["color"] | keyof typeof customChipColors;

export interface ForestChipProps extends Omit<ChipProps, "color"> {
  color?: ForestChipColor;
}

export type { ChipProps };

export function Chip({ color, deleteIcon = <CloseIcon />, sx, ...props }: ForestChipProps) {
  const custom = color && typeof color === "string" ? customChipColors[color] : undefined;

  if (custom) {
    return (
      <MuiChip
        deleteIcon={deleteIcon}
        {...props}
        sx={[
          {
            "&.MuiChip-root": {
              backgroundColor: custom.bg,
              color: custom.color,
              "& .MuiChip-deleteIcon": {
                color: custom.deleteIcon,
              },
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    );
  }

  return (
    <MuiChip
      color={color as ChipProps["color"]}
      deleteIcon={deleteIcon}
      sx={sx}
      {...props}
    />
  );
}
